import EnumPermissions from './enumPermissions';

export type OrganizationRole = 'admin' | 'manager' | 'editor' | 'editor_limited' | 'placeholder';

export interface OrganizationRoleLabel {
  label: string;
  article: string;
}

const RoleLabels = new Map<OrganizationRole, OrganizationRoleLabel>([
  [
    'admin',
    {
      label: 'Admin',
      article: 'an',
    },
  ],
  [
    'manager',
    {
      label: 'Manager',
      article: 'a',
    },
  ],
  [
    'editor',
    {
      label: 'Editor',
      article: 'an',
    },
  ],
  [
    'editor_limited',
    {
      label: 'Editor Limited',
      article: 'an',
    },
  ],
  [
    'placeholder',
    {
      label: "Please select the user's role",
      article: 'an',
    },
  ],
]);

export const getAllPerms = () => Object.values(EnumPermissions);

export const translateRoleToPermissions = (role: OrganizationRole): Array<EnumPermissions> => {
  if (role === 'admin') {
    return getAllPerms();
  }
  if (role === 'manager') {
    return [
      EnumPermissions.ACTIVATION,
      EnumPermissions.BILLING_VISIBLE,
      EnumPermissions.CHANGEPLAN,
      EnumPermissions.DEACTIVATE,
      EnumPermissions.SBCONFIG,
      EnumPermissions.SBTUNNEL,
    ];
  }
  if (role === 'editor') {
    return [EnumPermissions.BILLING_VISIBLE, EnumPermissions.SBCONFIG, EnumPermissions.SBTUNNEL];
  }
  if (role === 'editor_limited') {
    return [EnumPermissions.SBCONFIG, EnumPermissions.SBTUNNEL];
  }

  // If not specified, default to lowest (editor_limited)
  return [EnumPermissions.SBCONFIG, EnumPermissions.SBTUNNEL];
};

export const translatePermissionsToRole = (
  permissions?: Array<EnumPermissions>
): OrganizationRole => {
  if (!permissions) {
    return 'editor';
  }
  if (permissions.includes(EnumPermissions.ORG_MANAGEMENT)) {
    return 'admin';
  }
  if (
    permissions.includes(EnumPermissions.ACTIVATION) &&
    permissions.includes(EnumPermissions.CHANGEPLAN) &&
    permissions.includes(EnumPermissions.DEACTIVATE)
  ) {
    return 'manager';
  }
  if (permissions.includes(EnumPermissions.BILLING_VISIBLE)) {
    return 'editor';
  }

  // Defaulting to editor as the lowest common denominator role
  return 'editor_limited';
};

export const labelForRole = (role: OrganizationRole) =>
  RoleLabels.get(role) ?? RoleLabels.get('editor')!;
